import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/pages/utilities.css";

import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";
import bg3 from "../../assets/images/img/bg-3.svg";

import SalaryTax from "../../assets/images/utilities/salary-tax.jpg";

const utilities = [
  {
    id: 1,
    image: SalaryTax,
    title: "Salary Tax Calculator",
    description:
      "Calculate your exact Nepal income tax in seconds — IRD-compliant across all fiscal years. Factor in every legal deduction, see your slab-wise breakdown, and discover how much tax you can still save before year-end.",
    bullets: [
      "Covers EPF, SSF, CIT, life & health insurance, house rent, and donation deductions",
      "Instant slab-wise tax breakdown with personalised tips to legally reduce your tax liability",
    ],
    link: "https://salarytax.genvixtech.com/",
    linkLabel: "Calculate Your Tax Free",
  },
];

export default function Utilities() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");

  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className="landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> scroll down</font>
            </font>
          </h4>
        </div>

        <div className="section section__services">
          <img
            className="landing__image-background-1 image-background slide-from-right"
            src={bg3}
            alt="container background"
          />
          <div className="container services">
            <h5 id="scroll" className="drop-from-top">
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>Utilities</font>
              </font>
            </h5>
            <div className="title drop-from-top">
              <h2>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Tools built for your convenience
                  </font>
                </font>
              </h2>
            </div>

            {/* Utility Card Showcase */}
            <div className="utilities-list">
              {utilities.map((util, index) => (
                <div
                  className={`utility-section slide-from-bottom ${index % 2 !== 0 ? "utility-section--reverse" : ""}`}
                  key={util.id}
                >
                  <div className="utility-section__image">
                    <img src={util.image} alt={util.title} loading="lazy" />
                  </div>
                  <div className="utility-section__content">
                    <h2>{util.title}</h2>
                    <p className="utility-description">{util.description}</p>
                    <ul className="utility-bullet-list">
                      {util.bullets.map((b, i) => (
                        <li key={i}>
                          <div className="check-icon-badge">
                            <span className="check-icon-symbol">✓</span>
                          </div>
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="utility-card-actions">
                      <a
                        href={util.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn blue"
                      >
                        {util.linkLabel}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Clean Authentic Coming Soon Banner */}
            <div className="coming-soon-banner slide-from-bottom">
              <div className="coming-soon-content">
                <span className="coming-soon-badge">
                  <span className="badge-dot"></span> Coming Soon
                </span>
                <h3>More utilities on the way</h3>
                <p>
                  We're constantly building new tools to make your life easier. Check back soon for more utilities crafted by <b>Genvix Tech.</b> If custom tools are required, contact our team.
                </p>
              </div>
              <div className="coming-soon-action">
                <button
                  onClick={() => (window.location.href = "/contact")}
                  className="btn blue"
                >
                  Contact Our Team
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}